import React, { FC } from 'react';
import Image from 'components/image/Image';

import './Index.scss';
import useLocales from 'hooks/useLocales';
import { useTenantInfo } from 'hooks/useTenantInfo';
import colors from 'assets/variables/colors';

const Footer: FC = (): JSX.Element => {
  const { t } = useLocales();

  const {
    tenantPrivacyUrl,
    tenantTermUrl,
    tenantName,
    tenantFacebookUrl,
    tenantXUrl,
    tenantLinkedinUrl
  } = useTenantInfo();

  return (
    <div className="footer" style={{ backgroundColor: colors.tenantColor }}>
      <div className="footer__left">
        <span className="footer__left-item">{`© ${
          tenantName || 'Skillio'
        } 2025`}</span>
        <a
          href={tenantPrivacyUrl || '/privacy-policy'}
          target="blank"
          rel="noopener noreferrer"
          className="footer__left-item"
        >
          {t('Privacy statement')}
        </a>
        <a
          href={tenantTermUrl || '/terms-conditions'}
          target="blank"
          rel="noopener noreferrer"
          className="footer__left-item"
        >
          {t('General terms')}
        </a>
        <a href="/contactUs" className="footer__left-item">
          {t('Contact')}
        </a>
      </div>
      <div className="footer__right">
        {tenantLinkedinUrl && (
          <a
            href={tenantLinkedinUrl}
            target="blank"
            className="footer__right-item"
          >
            <Image name="linkedin1.svg" width={31} height={31} />
          </a>
        )}
        {tenantFacebookUrl && (
          <a
            href={tenantFacebookUrl}
            target="blank"
            className="footer__right-item"
          >
            <Image name="facebook1.svg" width={31} height={31} />
          </a>
        )}
        {tenantXUrl && (
          <a href={tenantXUrl} target="blank" className="footer__right-item">
            <Image name="x-white.svg" width={31} height={31} />
          </a>
        )}
      </div>
    </div>
  );
};

export default Footer;
